import { MealTime } from "@/clients/models/MealTime";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetGotoGenerationStatus = (mealTime: MealTime) => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: [QueryKeys.GO_TO_GENERATION_STATUS, mealTime],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.checkGotoGenerationStatusApiV1MealsGotoGenerationStatusMealTimeGet(
          mealTime,
          user.id,
        );
      return data;
    },
  });
  const isCompleted = data?.status === "completed";
  return {
    allGotoGenerationStatus: data,
    isLoading,
    error,
    refetch,
    isCompleted,
  };
};
